@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.backgroundImage {
    background-color: var(--color-white);
    background-image:
        url("../../../static/img/gc-glitter-left.png"),
        url("../../../static/img/gc-glitter-right.png"),
        url("../../../static/img/gc-glitter-small-only.png");
    background-position:
        -9% bottom,
        109% bottom,
        right top;
    background-repeat: no-repeat;
    background-size: auto, 0, auto;
    padding-bottom: 3.75rem;
    padding-top: 3.75rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        background: none;
    }
}

.featureWrapper {
    align-items: center;
    column-gap: 1rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0 auto;
    max-width: 73.75rem;

    @include breakpoint.breakpoint(layout.$belowLargeLine) {
        align-items: flex-start;
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }
}

.cardFeature {
    align-items: center;
    display: grid;
    grid-template-columns: 1fr 1fr;

    @include breakpoint.breakpoint(layout.$belowLargeLine) {
        grid-template-columns: 1fr;
    }

    &:nth-of-type(2) {
        & > picture {
            @include breakpoint.breakpoint(layout.$belowMedium) {
                order: -1;
            }
        }
    }

    & > div {
        margin: 0 auto;
        max-width: 18.75rem;
    }

    & > picture {
        margin: 0 auto;

        & img {
            max-width: 80%;
        }
    }
}

.cardCTAWrapper {
    display: flex;
    flex-wrap: wrap;
    margin-top: 3rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        padding: 0 12vw;
    }
}

.cardCTA {
    align-items: center;
    border-right: 1px solid var(--color-black);
    display: flex;
    flex-direction: column;
    width: 25%;

    &:last-of-type {
        border-right: none;
    }

    @include breakpoint.breakpoint(layout.$belowLargeLine) {
        &:nth-of-type(2n) {
            border-right: none;
        }

        margin-bottom: 4rem;
        width: 50%;
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        border-bottom: 1px solid var(--color-black);
        border-right: none;
        padding-bottom: 2rem;
        margin-bottom: 2rem;
        width: 100%;

        &:last-of-type {
            border-bottom: none;
        }
    }
}

.ctaHeading {
    padding: 0 0 2rem;
}
